function generateFallingLeafPath (startPosition, endPosition) {
    const x1 = startPosition.x
    const y1 = startPosition.y
    const x2 = endPosition.x
    const y2 = endPosition.y
    const numPoints = 100
    const minX = Math.min(x1, x2)
    const maxX = Math.max(x1, x2)
    const minY = Math.min(y1, y2)
    const maxY = Math.max(y1, y2)
    // 随机生成控制点，并确保它们不在同一条直线上
    let controlPoint1X, controlPoint1Y, controlPoint2X, controlPoint2Y
    do {
        controlPoint1X = minX + Math.random() * (maxX - minX)
        controlPoint1Y = minY + Math.random() * (maxY - minY)
        controlPoint2X = minX + Math.random() * (maxX - minX)
        controlPoint2Y = minY + Math.random() * (maxY - minY)
    } while (Math.abs((controlPoint2Y - controlPoint1Y) / (controlPoint2X - controlPoint1X)) ===
    Math.abs((y2 - y1) / (x2 - x1))); // 确保控制点不在同一条直线上
    // 生成轨迹点
    const path = []
    for (let t = 0; t <= 1; t += 1 / (numPoints - 1)) {
        const x = Math.pow(1 - t, 3) * x1 +
            3 * Math.pow(1 - t, 2) * t * controlPoint1X +
            3 * (1 - t) * Math.pow(t, 2) * controlPoint2X +
            Math.pow(t, 3) * x2;
        const y = Math.pow(1 - t, 3) * y1 +
            3 * Math.pow(1 - t, 2) * t * controlPoint1Y +
            3 * (1 - t) * Math.pow(t, 2) * controlPoint2Y +
            Math.pow(t, 3) * y2;
        path.push({ x: Math.max(minX, Math.min(x, maxX)), y: Math.max(minY, Math.min(y, maxY)) })
    }
    path.push({
        x: x2,
        y: y2
    })
    return path.slice(1, 101)
}

function generateLeafAnimationFrames () {
    const frames = []
    const steps = 100
    for (let i = 1; i < steps; i++) {
        const progress = i / steps
        const angleY = 360 * Math.sin(progress * Math.PI)
        const angleX = 10 * Math.sin(progress * Math.PI * 4)
        const angleZ = 10 * Math.cos(progress * Math.PI * 4)
        frames.push({
            rotationX: angleX,
            rotationY: angleY,
            rotationZ: angleZ
        });
    }
    frames.push({
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0
    })
    return frames
}
function generateCatmullRomPoints(start, end, numPoints) {
    const points = [];
    const tension = 0.5; // 张力参数，控制曲线的平滑度

    for (let i = 0; i <= numPoints; i++) {
        const t = i / numPoints;
        const t2 = t * t;
        const t3 = t2 * t;

        const x = (2 * t3 - 3 * t2 + 1) * start.x +
            (t3 - 2 * t2 + t) * tension * (end.x - start.x) +
            (-2 * t3 + 3 * t2) * end.x +
            (t3 - t2) * tension * (end.x - start.x);

        const y = (2 * t3 - 3 * t2 + 1) * start.y +
            (t3 - 2 * t2 + t) * tension * (end.y - start.y) +
            (-2 * t3 + 3 * t2) * end.y +
            (t3 - t2) * tension * (end.y - start.y);

        points.push({ x, y });
    }
    return points;
}

export default {
    generateLeafAnimationFrames,
    generateFallingLeafPath,
    generateCatmullRomPoints
}